export default __webpack_public_path__ + "fonts/3c457a16ceeddcf41f0bde54388e1df7.woff2";